import { render, staticRenderFns } from "./CompleteLiveWatchCard.vue?vue&type=template&id=5955c15e&scoped=true"
import script from "./CompleteLiveWatchCard.vue?vue&type=script&lang=ts"
export * from "./CompleteLiveWatchCard.vue?vue&type=script&lang=ts"
import style0 from "./CompleteLiveWatchCard.vue?vue&type=style&index=0&id=5955c15e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5955c15e",
  null
  
)

export default component.exports